/* eslint-disable */
import PropTypes from "prop-types";

// @mui material components
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import { Colors } from "utils/Constants";

function SidenavCollapse({ icon, name, active, parent, isExpandable, isExpanded, isChild, ...rest }) {
  const [controller] = useMaterialUIController();
  const { miniSidenav } = controller;

  const primaryColor = Colors?.PRIMARY || "#043b9f";

  // Dedicated rendering for Sub-menu Child items
  if (isChild) {
    return (
      <ListItem component="li" disablePadding sx={{ py: 0.2, position: "relative" }}>
        <MDBox
          {...rest}
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            py: 0.8,
            px: 2,
            position: "relative",
            borderRadius: "6px",
            backgroundColor: "transparent",
            cursor: "pointer",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: "#F2F4F7",
            },
            ...(active && {
              "&::before": {
                content: '""',
                position: "absolute",
                left: "-5px",
                top: 0,
                bottom: 0,
                width: "2.5px",
                backgroundColor: primaryColor,
                borderRadius: "2px",
                zIndex: 2,
              },
            }),
          }}
        >
          <ListItemText
            primary={name}
            primaryTypographyProps={{
              fontSize: "13px",
              fontWeight: active ? "600" : "500",
              color: active ? primaryColor : "#667085",
              style: {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
            }}
            sx={{ my: 0, opacity: miniSidenav ? 0 : 1 }}
          />
        </MDBox>
      </ListItem>
    );
  }

  // Top-Level Menu Items
  let bgColor = "transparent";
  let textColor = "#475467";
  let iconColor = "#667085";
  let fontWeight = "500";

  if (active) {
    bgColor = primaryColor;
    textColor = "#FFFFFF";
    iconColor = "#FFFFFF";
    fontWeight = "600";
  }

  return (
    <ListItem component="li" disablePadding sx={{ px: 1, py: 0.3 }}>
      <MDBox
        {...rest}
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          py: 1,
          px: 1.5,
          borderRadius: "6px",
          backgroundColor: bgColor,
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: active ? primaryColor : "#F2F4F7",
          },
        }}
      >
        {icon && (
          <ListItemIcon
            sx={{
              minWidth: "32px",
              color: iconColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {typeof icon === "string" ? (
              <Icon sx={{ color: iconColor, fontSize: "20px !important" }}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>
        )}

        <ListItemText
          primary={name}
          primaryTypographyProps={{
            fontSize: "14px",
            fontWeight: fontWeight,
            color: textColor,
            style: {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
          sx={{ my: 0, opacity: miniSidenav ? 0 : 1 }}
        />

        {isExpandable && !miniSidenav && (
          <Box display="flex" alignItems="center" ml="auto">
            {isExpanded ? (
              <KeyboardArrowUpIcon sx={{ color: textColor, fontSize: 18 }} />
            ) : (
              <KeyboardArrowDownIcon sx={{ color: textColor, fontSize: 18 }} />
            )}
          </Box>
        )}
      </MDBox>
    </ListItem>
  );
}

SidenavCollapse.defaultProps = {
  active: false,
  parent: "",
  isExpandable: false,
  isExpanded: false,
  isChild: false,
};

SidenavCollapse.propTypes = {
  icon: PropTypes.node,
  name: PropTypes.string.isRequired,
  parent: PropTypes.string,
  active: PropTypes.bool,
  isExpandable: PropTypes.bool,
  isExpanded: PropTypes.bool,
  isChild: PropTypes.bool,
};

export default SidenavCollapse;
